import * as React from 'react';
import type { SVGProps } from 'react';
const SvgObject = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.5 9.5v6.692h6.692V9.5zM2.5 8a.5.5 0 0 0-.5.5v8.692a.5.5 0 0 0 .5.5h8.692a.5.5 0 0 0 .5-.5V8.5a.5.5 0 0 0-.5-.5z"
      clipRule="evenodd"
    />
    <path d="M7.247 9h3.945a1 1 0 0 1 .077.006v-.341L9.943 8.51a2 2 0 0 0-.164-.01l-.08-.003a9 9 0 0 1-.83-.053 5 5 0 0 1-.232-.032A3.89 3.89 0 0 1 12.385 3.5a3.885 3.885 0 1 1-.693 7.708v1.517A5.385 5.385 0 1 0 7.246 9Z" />
  </svg>
);
export default SvgObject;
